import React from "react";

export default function Help() {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-700 dark:text-gray-300">
      <h1 className="text-3xl font-bold mb-6">Help & Support</h1>

      <p className="mb-4">
        This system is designed to help Village of Hope staff monitor the
        development, health, and wellbeing of children under their care.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">System Features</h2>

      <ul className="list-disc ml-6">
        <li>Child profile management</li>
        <li>Development milestone tracking</li>
        <li>Health record monitoring</li>
        <li>Donation management</li>
        <li>Notification and alert system</li>
        <li>Reporting and analytics</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">How to Use</h2>

      <ul className="list-disc ml-6">
        <li>Login using your authorized account.</li>
        <li>Navigate through modules using the sidebar.</li>
        <li>Update child records and development data regularly.</li>
        <li>Use the dashboard to monitor system alerts and updates.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Need Assistance?</h2>

      <p>
        If you encounter system issues or need assistance, please contact the
        system administrator or the Village of Hope IT support team.
      </p>
    </div>
  );
}